// Badge di stato leggibile: colore per famiglia di stato, non solo testo grigio.
const REGOLE = [
  { re: /(concluso|conclusa|completat|chiusa|archiviat|rilasciat|acquisit|approvat|esito.*praticabile)/i,
    cls: "bg-[#D8E6D2] text-[#2E5E3A]" },
  { re: /(respint|rifiutat|negat|scadut|nessuna via)/i,
    cls: "bg-[#F7E9E9] text-[#8A2E2E]" },
  { re: /(attesa|in richiesta|inviat|deposit|convocazione|coda|verifica|istruttoria)/i,
    cls: "bg-[#FDF6F1] text-[#9A3B13]" },
  { re: /(da avviare|preventivo|nuova)/i,
    cls: "bg-[#ECEAE3] text-[#4A4A48]" },
];

export const StatoBadge = ({ stato, testid, className = "" }) => {
  const cls = (REGOLE.find((r) => r.re.test(stato || "")) || {}).cls
    || "bg-[#ECEAE3] text-[#1B2A4B]";
  return (
    <span data-testid={testid} title={stato}
      className={`inline-flex items-center px-2.5 py-1 rounded-[3px] text-[12px] font-bold leading-none max-w-full ${cls} ${className}`}>
      <span className="truncate">{stato}</span>
    </span>
  );
};

export default StatoBadge;
